import { ExternalIntegrationCard } from '../ExternalIntegrationCard/ExternalIntegrationCard'
import { ExternalIntegrationEnum, MailchimpIntegration } from 'api/clients/ExternalIntegrationsClient'
import { Google } from 'blaze-ui/icons'
import { CardButtons } from './CardButtons'
import { useModals } from 'almanac-ui/Modal'
import { GoogleInitialization } from 'components/IntegrationInitialization'

export const GoogleCard = ({
  integrations = [],
  isDisconnected = false,
}: {
  integrations?: MailchimpIntegration[]
  isDisconnected?: boolean
}) => {
  const { openModal } = useModals()

  return (
    <ExternalIntegrationCard
      title="Google"
      description="Connect your Google Analytics account to measure how much traffic your content is generating"
      integrations={integrations}
      icon={<Google size={20} />}
      isDisconnected={isDisconnected}
      buttons={
        <CardButtons
          onConnect={() => openModal(GoogleInitialization)}
          provider={ExternalIntegrationEnum.Google}
          isConnected={integrations.length > 0}
          integration={integrations[0]}
          isDisconnected={isDisconnected}
        />
      }
    />
  )
}
